module.exports = "<p>Nothing to see here just yet</p>\n"


//////////////////
// WEBPACK FOOTER
// /zeit/1e2f5901/src/app/gallery/gallery.component.html
// module id = ../../../../../src/app/gallery/gallery.component.html
// module chunks = main